module.exports = __webpack_public_path__ + "static/img/reference pics_house3.8c540a4b.jpg";